import { render, staticRenderFns } from "./SupplierEditorPurchases.vue?vue&type=template&id=d3ed313a&"
import script from "./SupplierEditorPurchases.vue?vue&type=script&lang=js&"
export * from "./SupplierEditorPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports